/**
 * VoxResponse detail component
 */
import 'rxjs/add/observable/interval';

import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Observable } from 'rxjs';

import { ProfileService } from '../services/profile.service';
import { VoxPopService } from '../services/voxpop.service';
import { VoxResponse } from '../types/response';
import { AudioAPIWrapper } from './audio.wrapper';

enum State {
  Stopped = 1,
  Playing,
  Paused,
}


@Component({
  moduleId: module.id,
  selector: 'response-player',
  templateUrl: './response-player.component.html',
  styleUrls: ['./response-player.component.css'],
  providers: [VoxPopService],
})

export class VoxResponsePlayerComponent implements OnInit {
  @Input() response: VoxResponse;
  @Input() observableResponse: Observable<VoxResponse>;
  @Output() cancelPlayer: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() responseChange: EventEmitter<VoxResponse> = new EventEmitter<VoxResponse>();
  errorMessage: string;
  private audio: AudioAPIWrapper;
  audioURL: string;
  progressbarWidth: number = 0;
  duration: number;
  position: number;
  currentState: State = State.Stopped;
  positionObserver: Observable<number>;
  lastPosition: number = 0;

  constructor(
    private voxPopService: VoxPopService,
  ) { }

  ngOnInit(): void {
    if (!ProfileService.IsLoggedIn()) return;

    try {
      this.audio = new AudioAPIWrapper();
    } catch (e) {
      console.log(e.message);
    }

    this.observableResponse.subscribe(
      (r) => this.setVoxResponse(r),
    );
    console.log("So we should be subscribed now...");

    this.setVoxResponse(this.response);
  }

  Play() {
    if (this.currentState != State.Playing) try {
      this.audio.Play();
      this.currentState = State.Playing;
      this.startProgress();
      this.positionObserver.subscribe();
    } catch (e) {
      console.log(e.message);
    }
  }

  isPlaying(): boolean {
    return this.currentState == State.Playing;
  }

  Pause() {
    if (this.currentState == State.Playing) try {
      this.audio.Pause();
      this.currentState = State.Paused;
    } catch (e) {
      console.log(e.message);
    }
  }

  Stop() {
    try {
      this.setVoxResponse(this.response);
    } catch (e) {
      console.log(e.message);
    }
    this.currentState = State.Stopped;
    this.positionObserver = null;
    this.lastPosition = 0;
    this.progressbarWidth = 0;
  }

  Cancel() {
    this.cancelPlayer.emit(true);
  }

  startProgress() {
    let currentPosition: number;
    this.positionObserver = Observable
      .interval(50)
      .map(() => {
        try {
          currentPosition = Math.round(this.audio.CurrentTime(null) * 100) / 100;
          if (!this.duration || isNaN(this.duration)) {
            this.duration = Math.round(this.audio.GetDuration() * 100) / 100;
          }
          if (this.lastPosition != currentPosition) {
            this.lastPosition = currentPosition;
            this.progressbarWidth = (this.lastPosition / this.duration) * 100;
            // console.log("Pos: " + currentPosition + ", percentage: " + percentage + ", barWidth: " + this.progressbarWidth);
          }
        } catch (e) {
          console.log(e.message);
        }
        if (this.lastPosition >= this.duration) {
          this.Stop();
        }
        return this.lastPosition / this.duration;
      });
  }

  public progressBarPercent(): number {
    // console.log("Width: " + this.progressbarWidth);
    return this.progressbarWidth;
  }

  setVoxResponse(response: VoxResponse) {
    if (!response) return;
    console.log("Loaded response " + response.name + "(" + response.id + ")");
    if (!response.corrected_transcript) response.corrected_transcript = response.transcript;
    this.response = response;
    this.audioURL = `/api/private/r/audio/${this.response.id}/opus/${this.response.topic}-${this.response.id}-${this.response.name}.opus`;
    try {
      this.duration = this.audio.Load(this.audioURL);
      this.progressbarWidth = 0;
      if (isNaN(this.duration)) {
        this.duration = this.response.duration;
        this.Pause();
      }
    } catch (e) {
      console.log(e.message);
    }
  }

  responseSaved(response: VoxResponse): void {
    console.log("Response was saved: " + response.id);
    this.responseChange.emit(response);
  }

  updateTranscript(): void {
    let savedResponse = this.response;
    console.log("Saving response: " + savedResponse.id);
    this.voxPopService.updateResponse(savedResponse).subscribe(
      () => this.responseSaved(savedResponse),
    )
  }
}
